import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { brl, dateFmt } from "@/lib/format";

const statusColor = {
  Rascunho: "bg-slate-800 text-slate-300 border-slate-700",
  Enviado: "bg-blue-950 text-blue-300 border-blue-800",
  Aprovado: "bg-emerald-950 text-emerald-300 border-emerald-800",
  Rejeitado: "bg-red-950 text-red-300 border-red-800",
  "Em Produção": "bg-amber-950 text-amber-300 border-amber-800",
};

export default function Quotes() {
  const [list, setList] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/quotes").then((r) => setList(r.data));
  }, []);

  const filtered = list.filter(
    (x) =>
      !q ||
      x.number?.toLowerCase().includes(q.toLowerCase()) ||
      x.status?.toLowerCase().includes(q.toLowerCase()),
  );

  return (
    <div className="space-y-5">
      <header className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <div className="text-[11px] mono uppercase tracking-[0.3em] text-orange-400/80">
            operacional · orçamentos
          </div>
          <h1 className="display text-3xl font-bold mt-1">Histórico de Orçamentos</h1>
        </div>
        <Link
          to="/orcamentos/novo"
          className="pill-accent rounded-md px-4 py-2 text-sm font-semibold"
          data-testid="quotes-new-button"
        >
          + Novo
        </Link>
      </header>

      <input
        placeholder="Buscar por número ou status…"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        className="w-full max-w-md bg-slate-900 border border-slate-700 rounded px-3 py-2 text-sm"
        data-testid="quotes-search-input"
      />

      <div className="card-tactical rounded-lg overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-900/60 text-[11px] uppercase tracking-wider text-slate-400">
              <tr>
                <th className="text-left px-4 py-2.5">Nº</th>
                <th className="text-left px-4 py-2.5">Data</th>
                <th className="text-left px-4 py-2.5">Status</th>
                <th className="text-right px-4 py-2.5">Corte (m)</th>
                <th className="text-right px-4 py-2.5">Furos</th>
                <th className="text-right px-4 py-2.5">Total</th>
              </tr>
            </thead>
            <tbody data-testid="quotes-tbody">
              {filtered.map((q_) => (
                <tr key={q_.id} className="border-t border-slate-800 hover:bg-slate-800/30">
                  <td className="px-4 py-3">
                    <Link
                      to={`/orcamentos/${q_.id}`}
                      className="mono text-orange-300 hover:underline"
                      data-testid={`quote-row-${q_.number}`}
                    >
                      {q_.number}
                    </Link>
                  </td>
                  <td className="px-4 py-3 text-slate-300">{dateFmt(q_.created_at)}</td>
                  <td className="px-4 py-3">
                    <span
                      className={`text-xs px-2 py-0.5 rounded-full border ${
                        statusColor[q_.status] || statusColor.Rascunho
                      }`}
                    >
                      {q_.status}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-right mono text-slate-300">
                    {q_.totals?.total_cut_length_m?.toFixed(3)}
                  </td>
                  <td className="px-4 py-3 text-right mono text-slate-300">
                    {q_.totals?.total_holes}
                  </td>
                  <td className="px-4 py-3 text-right mono text-orange-300">
                    {brl(q_.totals?.total)}
                  </td>
                </tr>
              ))}
              {filtered.length === 0 && (
                <tr>
                  <td colSpan={6} className="py-10 text-center text-slate-500 text-sm">
                    Nenhum orçamento
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
